import { createAction } from "@ngrx/store";

export const setLoading = createAction(
    '[Loading] Set isLoading to true'
);

export const unsetLoading = createAction(
    '[Loading] Set isLoading to false'
)